export default "__VITE_ASSET__aa813b6c__"